// pages/Products/ProductsList.js

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  UncontrolledTooltip,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";
import PageTitle from "../../components/Common/PageTitle";
import { SetStatusStyle, ShowNotification } from "../../helpers/general/generalHelpers";
import Loader from "../../shared/loader/loader";
import {
  getPaginationInformation,
  initialPaginationObject,
} from "../../helpers/general/pagination";
import { deleteProduct, getProducts } from "./services/product-service";

const ProductsList = (props) => {
  const [products, setProducts] = useState([]);
  const [pagination, setPagination] = useState(initialPaginationObject);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [isDeleted, setIsDeleted] = useState(false);

  // State for delete confirmation modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productIdToDelete, setProductIdToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false); // <-- New state for button loader

  if (props.location.notification?.show) {
    ShowNotification({ type: "success", message: props.location.notification.message });
    props.location.notification = null;
  }

  useEffect(() => {
    setLoader(true);
    getProducts(currentPage, null)
      .then((response) => {
        setProducts(response.data.products);
        setPagination(
          getPaginationInformation(response.data.count || response.data.Count || 0, currentPage)
        );
      })
      .catch((error) => {
        const message = error?.response?.data?.message || "Error fetching products.";
        ShowNotification({ type: "error", message });
      })
      .finally(() => {
        setLoader(false);
      });
  }, [isDeleted, currentPage]);

  function paginate(pageNumber) {
    setCurrentPage(pageNumber);
  }

  // Opens the confirmation modal
  const handleDeleteClick = (id) => {
    setProductIdToDelete(id);
    setShowDeleteModal(true);
  };

  // Closes the confirmation modal
  const handleCloseModal = () => {
    setShowDeleteModal(false);
    setProductIdToDelete(null);
  }

  // Handles the actual deletion after confirmation
  async function confirmDeleteHandler() {
    if (productIdToDelete) {
      try {
        setIsDeleting(true); // <-- Start button loader
        await deleteProduct(productIdToDelete);
        ShowNotification({ type: "success", message: "Product deleted successfully!" });
        setIsDeleted(!isDeleted);
      } catch (error) {
        const message = error?.response?.data?.message || "Error deleting product.";
        ShowNotification({ type: "error", message });
      } finally {
        setIsDeleting(false); // <-- Stop button loader
        handleCloseModal();
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="relative">
          <Loader loading={loader} />
          <PageTitle title="Products" button name="+ Add New Product" url="/products" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table-centered table-nowrap table-hover">
                      <thead className="thead-light font-size-15">
                        <tr>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Price</th>
                          <th>Duration (Days)</th>
                          <th>Sales Status</th>
                          <th>Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody className="agora-lato">
                        {products.map((product) => {
                          const typeLabels = {
                            'subject': 'Subject',
                            'past_paper': 'Past Paper',
                            'assessment': 'Assessment',
                            'study_guide': 'Study Guide',
                            'bundle': 'Bundle'
                          };
                          const displayType = Array.isArray(product.type)
                            ? product.type.map(t => typeLabels[t] || t).join(', ')
                            : (typeLabels[product.type] || product.type);
                          return (
                            <tr key={product._id}>
                              <td>{product.name}</td>
                              <td>{displayType}</td>
                              <td>{product.price} PKR</td>
                              <td>{product.accessDurationDays}</td>
                              <td>
                                {product.isPurchased ?
                                  <Badge color="success" className="font-size-12">In-Use</Badge> :
                                  <Badge color="secondary" className="font-size-12">Fresh</Badge>
                                }
                              </td>
                              <td><SetStatusStyle status={product.isActive ? "Active" : "Inactive"} /></td>
                              <td className="text-center">
                                <ul className="list-inline font-size-20 contact-links mb-0">
                                  <li className="list-inline-item px-2">
                                    <Link
                                      to={{ pathname: "/products", search: "?id=" + product._id }}
                                      id={"edit-product" + product._id}
                                    >
                                      <i className="bx bxs-edit-alt"></i>
                                      <UncontrolledTooltip placement="top" target={"edit-product" + product._id}>Edit</UncontrolledTooltip>
                                    </Link>
                                  </li>
                                  <li className="list-inline-item px-2">
                                    {/* --- UPDATED: Allow deletion even if purchased --- */}
                                    <Link
                                      to="#"
                                      id={"delete-product" + product._id}
                                      onClick={() => handleDeleteClick(product._id)}
                                    >
                                      <i className="bx bxs-trash"></i>
                                      <UncontrolledTooltip placement="top" target={"delete-product" + product._id}>Delete</UncontrolledTooltip>
                                    </Link>

                                    {/* { !product.isPurchased ? (
                                  <Link
                                    to="#"
                                    id={"delete-product" + product._id}
                                    onClick={() => handleDeleteClick(product._id)}
                                  >
                                    <i className="bx bxs-trash"></i>
                                    <UncontrolledTooltip placement="top" target={"delete-product" + product._id}>Delete</UncontrolledTooltip>
                                  </Link>
                                ) : (
                                  <span id={"disabled-delete-" + product._id} style={{ cursor: 'not-allowed' }}>
                                      <i className="bx bxs-trash text-muted"></i>
                                      <UncontrolledTooltip placement="top" target={"disabled-delete-" + product._id}>
                                          Cannot delete a product that has been sold.
                                      </UncontrolledTooltip>
                                  </span>
                                )} */}
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row>
                    <Col lg="12">
                      <Pagination className="pagination pagination-rounded justify-content-center mt-4">
                        <PaginationItem disabled={pagination.currentPage === 1}>
                          <PaginationLink
                            first
                            onClick={(e) => {
                              paginate(1);
                            }}
                          />
                        </PaginationItem>
                        <PaginationItem disabled={pagination.currentPage === 1}>
                          <PaginationLink
                            previous
                            onClick={(e) => {
                              paginate(pagination.currentPage - 1);
                            }}
                          />
                        </PaginationItem>
                        {pagination.pages.map((page, index) => (
                          <PaginationItem
                            key={"_page_" + index}
                            active={page === pagination.currentPage}
                          >
                            <PaginationLink
                              onClick={(e) => {
                                paginate(page);
                              }}
                            >
                              {page}
                            </PaginationLink>
                          </PaginationItem>
                        ))}
                        <PaginationItem
                          disabled={
                            pagination.currentPage === pagination.totalPages
                          }
                        >
                          <PaginationLink
                            next
                            onClick={(e) => {
                              paginate(pagination.currentPage + 1);
                            }}
                          />
                        </PaginationItem>
                        <PaginationItem
                          disabled={
                            pagination.currentPage === pagination.totalPages
                          }
                        >
                          <PaginationLink
                            last
                            onClick={(e) => {
                              paginate(pagination.totalPages);
                            }}
                          />
                        </PaginationItem>
                      </Pagination>
                      {pagination.totalItems > 0 && (
                        <div className="records-count text-center">
                          <p>
                            Showing <strong>{pagination.startIndex + 1}</strong>{" "}
                            to <strong>{pagination.endIndex + 1}</strong> of{" "}
                            <strong>{pagination.totalItems}</strong> records
                          </p>
                        </div>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} toggle={handleCloseModal} centered>
        <ModalHeader toggle={handleCloseModal}>Delete Product?</ModalHeader>
        <ModalBody>
          <div className="text-center">
            <div className="mb-4">
              <i className="bx bx-trash display-4 text-danger"></i>
            </div>
            <h4>Are you sure you want to delete this product?</h4>
            <p className="text-muted mb-0">This action cannot be undone.</p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCloseModal} disabled={isDeleting}>
            Cancel
          </Button>
          <Button color="danger" onClick={confirmDeleteHandler} disabled={isDeleting}>
            {isDeleting ? (
              <>
                <Spinner size="sm" className="me-2"> Loading... </Spinner>
                <span>Deleting...</span>
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </ModalFooter>
      </Modal>

    </React.Fragment>
  );
};

export default ProductsList;